import Head from 'next/head';
import kebabCase from 'lodash/kebabCase';

const JobsJsonLd = ({name, jobs}: {name: string; jobs: any}) => {
  const itemListElements = jobs?.map(
    (
      job: {
        id: any;
        title: any;
        slug: any;
      },
      index: number
    ) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: job.title,
      url: `${process.env.NEXT_PUBLIC_LOAD_CONFIG}/j/${kebabCase(
        job?.title?.replace(/&/g, '-and-')
      )}-${job?.id}`,
    })
  );

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: `${name}`,
    numberOfItems: jobs.length ?? 0,
    itemListElement: itemListElements,
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{__html: JSON.stringify(jsonLd)}}
      />
    </Head>
  );
};

export default JobsJsonLd;
